import { IFeatureGiftQuery, useFeatureGiftQuery } from 'generated/sanity-graphql';
import { useFeaturesContext } from 'state/features';

interface IUseFeatureGift {
  featureGiftLoading: boolean;
  featureGift: IFeatureGiftQuery['FeatureGift'];
}

export const useFeatureGift = (): IUseFeatureGift => {
  const { featureGiftId = '', featureIdsLoading } = useFeaturesContext();

  const { data, loading } = useFeatureGiftQuery({
    variables: { featureGiftId },
    skip: !featureGiftId,
  });

  const featureGift = data?.FeatureGift ?? null;
  const featureGiftLoading = featureIdsLoading || loading;

  return { featureGiftLoading, featureGift };
};
